import { Option, SelectInputProps } from 'components/SelectInput/SelectInput';

const findSelectedOption = (options: Option[], value: SelectInputProps['value']) =>
  options.find((option) => option.value === value);

export { findSelectedOption };
